<template>
    <div>
        <router-link :to="{ name: 'selectContent', query: { source_uri: contentUri, title: contentTitle, showSnsShare: showSnsShare }, }"
            :show-sns-share="showSnsShare" class="text-decoration-none">
            <div class="content-tile">
                <div class="content-tile__thumbnail content-tile__thumbnail--default rounded-lg">
                    <div class="content-tile-thumbnail__cover rounded-lg" :style="{ backgroundImage: `url(${thumbnailUri})` }"></div>
                </div>
                <div class="content-tile__body content-tile-body">
                    <div class="content-tile-body__title ellipsis1">{{ contentTitle }}</div>
                    <div class="content-tile-body__author ellipsis1">{{ contentAuthor }}</div>
                    <div class="content-tile-body__lead ellipsis2">{{ removeHtmlTags(contentLead) }}</div>
                    <div class="content-tile-body__timestamp">{{ timestamp }}</div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import Helper from "../assets/js/helper"

export default {
    name: 'ArticleTile',
    props: [
        'timestamp',
        'contentUri',
        'thumbnailUri',
        'contentTitle',
        'contentLead',
        'contentAuthor',
        'showSnsShare'
    ],
    data: () => ({}),
    // コンポーネントマウントリスナ
    mounted() { },
    methods: {
        removeHtmlTags: str => {
            return Helper.removeHtmlTags(str);
        }
    }
}
</script>

<style scoped>
.content-tile {
    display: flex;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
}

.content-tile__thumbnail {
    width: 100px;
    min-width: 100px;
    aspect-ratio: 1;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.content-tile__thumbnail--default {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #aaa;
    background-image: url('../assets/images/empty.gif');
}

.content-tile-thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.content-tile__body {
    width: calc(100% - 100px);
}

.content-tile-body {
    display: flex;
    flex-flow: column;
    text-align: left;
    padding: 4px 0;
}

.content-tile-body__title {
    font-size: 14px;
    color: #333;
}

.content-tile-body__author {
    font-size: 12px;
    color: #666;
}
.content-tile-body__timestamp {
    font-size: 11px;
    color: #666;
}

.content-tile-body__lead {
    font-size: 11px;
    color: #666;
    margin-top: auto;
}

</style>
